// keyCode
export const KEY_CODE = {
  // 字母键
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 88,
  Z: 90,
  0: 48,
  1: 49,
  2: 50,
  3: 51,
  4: 52,
  5: 53,
  6: 54,
  7: 55,
  8: 56,
  9: 57,

  // 数字键盘
  n0: 96,
  n1: 97,
  n2: 98,
  n3: 99,
  n4: 100,
  n5: 101,
  n6: 102,
  n7: 103,
  n8: 104,
  n9: 105,

  // 功能键
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  ctrl: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  esc: 27,
  space: 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  insert: 45,
  delete: 46,
  '*': 106,
  '+': 107,
  '-': 109,
  '.': 110,
  '/': 111,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  // N: 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222,
  f1: 112,
  f2: 113,
  f3: 114,
  f4: 115,
  f5: 116,
  f6: 117,
  f7: 118,
  f8: 119,
  f9: 120,
  f10: 121,
  f11: 122,
  f12: 123,
}

// 根据 value 获取 keyCode key
export const getKeyCode = (value) => {
  for (let key in KEY_CODE) {
    if (KEY_CODE[key] === value) {
      return key
    }
  }
}
